export default __webpack_public_path__ + "static/media/liquidity-pool.cad01191.png";